<div style="width:680px; min-height:500px">
  <div class="row">
    <div class="col-2">
      <input id="rad_searchbyNPI" type="radio" name="rad_npisearchtype" value="npi" [(ngModel)]="searchType" checked="checked" /> <label for="rad_searchbyNPI">by NPI</label>
    </div>
    <div class="col-10" [hidden]="searchType != 'npi'">
      <input type="text" [(ngModel)]="searchNPI" class="search" (keyup.enter)="doSearch()" />
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <input id="rad_searchbyName" type="radio" name="rad_npisearchtype" value="name" [(ngModel)]="searchType" /> <label for="rad_searchbyName">by name</label>
    </div>
    <div class="col-4" [hidden]="searchType != 'name'">
      <label for="searchFirst">First Name</label>
      <input id="searchFirst" type="text" [(ngModel)]="searchFirst" class="search" (keyup.enter)="doSearch()" />
    </div>
    <div class="col-6" [hidden]="searchType != 'name'">
      <label for="searchFirst">Last Name</label>
      <input id="searchLast" type="text" [(ngModel)]="searchLast" class="search" (keyup.enter)="doSearch()" />
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-4">
    </div>
    <div class="col-6">
      <button (click)="doSearch()" class="search" [hidden]="!canSearch()" >Search&nbsp;<i class="fa fa-search"></i></button>
    </div>
  </div>
  <div [hidden]="searchResults==null || searchResults.length == 0">
  <hr />
    <div class="row">
      <div class="col-12 font-italic">
        Click a provider below to add them
      </div>
    </div>
    <div class="row">
      <div class="col-2 font-weight-bold text-center">
        NPI
      </div>
      <div class="col-6 font-weight-bold text-center">
        Name
      </div>
      <div class="col-4 font-weight-bold text-center">
        Location
      </div>
    </div>
    <div class="row selectableDiv" *ngFor="let result of searchResults; index as i" (click)="selectResult(i)">
      <div class="col-2 text-center">
        {{result.ProviderNPI}}
      </div>
      <div class="col-6">
        {{result.ProviderFullName}}
      </div>
      <div class="col-4">
        {{result.City}}, {{result.State}}
      </div>
    </div>
  </div>
</div>
